module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Thin.6469a455.eot";